import '../assets/NcRadioGroup-CNgjqqiP.css';
import { defineComponent, mergeModels, useModel, ref, provide, computed, warn, createElementBlock, openBlock, normalizeClass, unref, createElementVNode, createCommentVNode, toDisplayString, renderSlot } from "vue";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { I as INSIDE_RADIO_GROUP_KEY } from "./useNcRadioGroup-DaZbEKbf.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _hoisted_1 = ["aria-describedby"];
const _hoisted_2 = ["id"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcRadioGroup",
  props: /* @__PURE__ */ mergeModels({
    label: {},
    labelHidden: { type: Boolean },
    description: {}
  }, {
    "modelValue": { required: false, default: "" },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const modelValue = useModel(__props, "modelValue");
    const descriptionId = createElementId();
    const buttonVariant = ref();
    provide(INSIDE_RADIO_GROUP_KEY, computed(() => ({
      register,
      modelValue: modelValue.value,
      onUpdate
    })));
    function register(isButton) {
      if (buttonVariant.value !== void 0 && buttonVariant.value !== isButton) {
        warn("[NcRadioGroup] Mixing NcCheckboxRadioSwitch and NcRadioGroupButton is not possible!");
      }
      buttonVariant.value = isButton;
    }
    function onUpdate(value) {
      modelValue.value = value;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("fieldset", {
        "aria-describedby": _ctx.description ? unref(descriptionId) : void 0,
        class: normalizeClass([{
          [_ctx.$style.radioGroup_buttonVariant]: buttonVariant.value
        }, _ctx.$style.radioGroup])
      }, [
        createElementVNode("legend", {
          class: normalizeClass([_ctx.$style.radioGroup__label, { "hidden-visually": _ctx.labelHidden }])
        }, toDisplayString(_ctx.label), 3),
        _ctx.description ? (openBlock(), createElementBlock("p", {
          key: 0,
          id: unref(descriptionId),
          class: normalizeClass(_ctx.$style.radioGroup__description)
        }, toDisplayString(_ctx.description), 11, _hoisted_2)) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass(_ctx.$style.radioGroup__wrapper)
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 10, _hoisted_1);
    };
  }
});
const radioGroup = "_radioGroup_u3tih_20";
const radioGroup_buttonVariant = "_radioGroup_buttonVariant_u3tih_24";
const radioGroup__label = "_radioGroup__label_u3tih_28";
const radioGroup__description = "_radioGroup__description_u3tih_34";
const radioGroup__wrapper = "_radioGroup__wrapper_u3tih_40";
const style0 = {
  "material-design-icon": "_material-design-icon_u3tih_12",
  radioGroup,
  radioGroup_buttonVariant,
  radioGroup__label,
  radioGroup__description,
  radioGroup__wrapper
};
const cssModules = {
  "$style": style0
};
const NcRadioGroup = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  NcRadioGroup as N
};
//# sourceMappingURL=NcRadioGroup-B_BNFM6V.mjs.map
